export enum EMPLOYEE_CREDIT_CUSTOMER_UPDATE_ERRORS {
  NOT_FOUND = 'Employee not found in the business!',
  ALREADY_SET = 'Credit recipient account has already been set!',
  OTHER = 'Something went wrong!',
}
